import * as React from 'react';

import { Image } from './careers-progress-stripes.styles';

export const StripesView = ({ className, imageSrc }) => (
  <Image className={className} src={imageSrc} alt="" />
);
